export default __webpack_public_path__ + "static/media/bike-computer-za-site-4.5699ce3d.jpg";